var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTd = function SvgTd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#002664",
    d: "M0 0h214v480H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c60c30",
    d: "M426 0h214v480H426z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fecb00",
    d: "M214 0h212v480H214z"
  }))));
};
export default SvgTd;